/*!
 * devextreme-vue
 * Version: 22.1.6
 * Build date: Tue Oct 18 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createExtensionComponent = exports.createConfigurationComponent = exports.createComponent = void 0;
var vue_1 = require("vue");
var component_1 = require("../../component");
var configuration_component_1 = require("../../configuration-component");
var extension_component_1 = require("../../extension-component");
var vue_helper_1 = require("../../vue-helper");
function createComponent(config) {
    config.extends = component_1.initDxComponent();
    vue_helper_1.setCompatOptions(config);
    if (config.model) {
        vue_helper_1.setVModel(config);
    }
    return vue_1.defineComponent(config);
}
exports.createComponent = createComponent;
function createConfigurationComponent(config) {
    config.extends = configuration_component_1.initDxConfiguration();
    vue_helper_1.setCompatOptions(config);
    return vue_1.defineComponent(config);
}
exports.createConfigurationComponent = createConfigurationComponent;
function createExtensionComponent(config) {
    config.extends = extension_component_1.initDxExtensionComponent();
    vue_helper_1.setCompatOptions(config);
    return vue_1.defineComponent(config);
}
exports.createExtensionComponent = createExtensionComponent;
